'use client';

import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { LocaleProvider } from '@/contexts/LocaleContext';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleToggle = () => setSidebarCollapsed((prev) => !prev);

  return (
    <LocaleProvider>
      <div className="min-h-screen" style={{ background: 'var(--background)' }}>
        <Sidebar collapsed={sidebarCollapsed} onToggle={handleToggle} />
        <Topbar sidebarCollapsed={sidebarCollapsed} onSidebarToggle={handleToggle} />
        <main
          className="min-h-screen pt-16 transition-all duration-300"
          style={{ marginLeft: sidebarCollapsed ? '64px' : '240px' }}
        >
          <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 py-8">
            {children}
          </div>
        </main>
      </div>
    </LocaleProvider>
  );
}